import React from "react";

// Minimal markdown renderer: ## / ### headings, - bullet lists, 1. ordered lists, **bold**, paragraphs.
function inline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? <strong key={i}>{p.slice(2, -2)}</strong> : <React.Fragment key={i}>{p}</React.Fragment>
  );
}

export default function Markdown({ content }) {
  if (!content) return null;
  const lines = content.split("\n");
  const blocks = [];
  let list = null;
  let ordered = null;

  const flush = () => {
    if (list) { blocks.push(<ul key={blocks.length}>{list.map((it, i) => <li key={i}>{inline(it)}</li>)}</ul>); list = null; }
    if (ordered) { blocks.push(<ol key={blocks.length}>{ordered.map((it, i) => <li key={i}>{inline(it)}</li>)}</ol>); ordered = null; }
  };

  lines.forEach((raw) => {
    const line = raw.trimEnd();
    if (line.startsWith("### ")) { flush(); blocks.push(<h3 key={blocks.length}>{inline(line.slice(4))}</h3>); }
    else if (line.startsWith("## ")) { flush(); blocks.push(<h2 key={blocks.length}>{inline(line.slice(3))}</h2>); }
    else if (/^\s*-\s+/.test(line)) { if (ordered) flush(); (list = list || []).push(line.replace(/^\s*-\s+/, "")); }
    else if (/^\s*\d+\.\s+/.test(line)) { if (list) flush(); (ordered = ordered || []).push(line.replace(/^\s*\d+\.\s+/, "")); }
    else if (line.trim() === "") { flush(); }
    else { flush(); blocks.push(<p key={blocks.length}>{inline(line)}</p>); }
  });
  flush();

  return <div className="prose-rino">{blocks}</div>;
}
